<template>
  <div id="basic-info" class="card mt-4">
    <div class="card-header">
      <h5>Stammdaten</h5>
      <p>
        Folgende Stammdaten haben wir aktuell in unseren Systemen zu Ihnen erfasst.
      </p>    
    </div>

    <div class="card-body pt-0">
      <div class="d-flex align-items-center">
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.id }}</p>
            <p class="mb-0 text-xs">Kundennummer</p>
          </div>
        </div>
      </div>       
      <hr class="horizontal dark" />
      <div class="d-flex align-items-center">
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.firstname }}</p>
            <p class="mb-0 text-xs">Vorname</p>
          </div>
        </div>
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.lastname }}</p>
            <p class="mb-0 text-xs">Nachname</p>
          </div>
        </div>
      </div>
      <hr class="horizontal dark" />
      <div class="d-flex align-items-center">
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.street }}</p>
            <p class="mb-0 text-xs">Straße</p>
          </div>
        </div>
      </div>
      <hr class="horizontal dark" />
      <div class="d-flex align-items-center">
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.postcode }}</p>
            <p class="mb-0 text-xs">Postleitzahl</p>
          </div>
        </div>
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="mb-1">{{ mandant.city }}</p>
            <p class="mb-0 text-xs">Stadt</p>
          </div>
        </div>
      </div>
      <br/>
      <p>Wenn Sie eine Änderung Ihrer Stammdaten wünschen, kontaktieren Sie uns einfach per Mail an <a href="mailto:customer.care@twl-kom.de">customer.care@twl-kom.de</a></p>
    </div>
  </div>

  <div id="password" class="card mt-4">
    <div class="card-header">
      <h5>Kennwort ändern</h5>
    </div>
    <div class="card-body pt-0">
      <h6>Kennwortanforderungen</h6>
      <p>Folgende Komplexitätsanforderungen gelten für Passwörter:</p>
      <ul class="mb-0 float-start">
        <li>Mindestens je eine Zahl, Sonderzeichen, Groß- und Kleinbuchstabe</li>
        <li>Mindestens 15 Zeichen</li>
      </ul>
    </div>
    
    <form role="form" class="text-start mt-3" @submit.prevent="changepw">
      <div class="card-body pt-0">
        <div class="mb-3">
          <material-input
            id="oldPassword"
            type="password"
            value=""
            label="Aktuelles Kennwort"
            @input="checkLocalPassword()"
          /> 
        </div>
        <div class="mb-3">
          <material-input
            id="newPassword"
            type="password"
            value=""
            label="Neues Kennwort"
            @input="checkLocalPassword()"/>
        </div>
        <div class="mb-3">
          <material-input
            id="newPassword2"
            type="password"
            value=""
            label="Neues Kennwort bestätigen"
            @input="checkLocalPassword()"/>
        </div>
        <div v-if="errormessageText != ''"><material-alert color="danger">{{ errormessageText }}</material-alert></div>
        
        <material-button
          class="mt-6 mb-0"
          variant="filled"
          color="success"
          size="sm"
          :disabled=!passwordOK
          @click="updateLocalPassword()"
        >Kennwort ändern</material-button>
      </div>
    </form>
  </div>

  <div id="2fa" class="card mt-4">
    <div class="card-header d-flex">
      <h5 class="mb-0">Zwei-Faktor-Authentifizierung</h5>
      <material-badge :color="google2FAEnabled ? 'success' : 'warning'" class="ms-auto">
        {{ google2FAEnabled ? 'Aktiviert' : 'Nicht aktiviert' }}
      </material-badge>      
    </div>
    <div class="card-body pt-0">
      <p v-if="!google2FAEnabled">
        Standardmäßig erhalten Sie einen Code per E-Mail bei jedem Login. Optional können Sie Google Authenticator einrichten, um die Zwei-Faktor-Authentifizierung zu nutzen.
      </p>
      <p v-else>
        Sie nutzen aktuell die Zwei-Faktor-Authentifizierung per Google Authenticator. Sie können dies durch die Eingabe eines letzten OTP-Tokens deaktivieren. Nach der Deaktivierung ist wieder die Zwei-Faktor-Authentifizierung per Mail aktiv.
      </p>

      <!-- Google2FA einrichten -->
      <div v-if="!google2FAEnabled && !showGoogle2FASetup">
        <material-button
          variant="filled"
          color="primary"
          size="sm"
          @click="startGoogle2FASetup"
        >
          Google2FA einrichten
        </material-button>
      </div>


      <!-- Setup Dialog -->
      <div v-if="showGoogle2FASetup" class="mt-3">
        <p><b>Schritt 1:</b> Scannen Sie den QR-Code in Ihrer Google Authenticator App oder geben Sie das Secret manuell ein:</p>
        <div v-if="google2FAConfig.url">
          <img :src="qrCodeUrl" alt="QR Code" />
          <p class="mt-2">Secret: {{ google2FAConfig.secret }}</p>
        </div>
        <p><b>Schritt 2:</b> Durch die Eingabe eines gültigen OTP-Tokens wird die Zwei-Faktor-Authentifizierung per Google freigeschaltet.<br/></p>
        <material-input
          v-model="firstOTP"
          label="Erster OTP-Code"
          type="text"
          maxlength="6"
          class="mt-3"
        />
        <material-button
          class="mt-2"
          variant="filled"
          color="success"
          size="sm"
          :disabled="firstOTP.length !== 6"
          @click="confirmGoogle2FA"
        >
          Bestätigen
        </material-button>
      </div>

      <!-- Google2FA zurücksetzen -->
      <div v-if="google2FAEnabled && !showGoogle2FASetup">
        <material-button
          variant="filled"
          color="warning"
          size="sm"
          @click="promptResetGoogle2FA"
        >
          Google2FA zurücksetzen
        </material-button>
      </div>

      <div v-if="google2FAError" class="mt-2">
        <material-alert color="danger">{{ google2FAError }}</material-alert>
      </div>
    </div>
  </div>

  <div id="sessions" class="card mt-4">
    <div class="card-header pb-3">
      <h5>Letzte erfolgreiche Logins</h5>
      <p>In dieser Auflistung können Sie nachvollziehen wann und mit welchem Gerät (Agent) die letzten Logins mit Ihrem Zugang stattgefunden haben.</p>
    </div>

    <div class="card-body pt-0">
      <div class="d-flex align-items-center" v-for="login in logins" :key="login.uuid">
        <div class="text-center w-5">
          <i class="fas fa-desktop text-lg opacity-6"></i>
        </div>
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="text-sm mb-1">{{login.agent}}</p>
            <p class="mb-0 text-xs">Am {{convertTimestampToDateTime(login.time_created)}} mit der öffentlichen IP {{login.ip}}</p>
          </div>
        </div>
        <material-badge color="success" size="sm" class="my-auto ms-auto me-3">Erfolgreich</material-badge>
      </div>
      <hr class="horizontal dark" />
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialBadge from "@/components/MaterialBadge.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";
import MaterialInput from "@/components/MaterialInput2.vue";
import Swal from 'sweetalert2';
import axios from 'axios';

export default {
  name: "SideNavItem",
  components: { MaterialButton, MaterialBadge, MaterialInput, MaterialAlert },
  data() {
    return {
    mandant: {
      id: '',
      firstname: '',
      lastname: '',
      street: '',
      postcode: '',
      city: ''
    },
      logins: [],
      errormessageText: "",
      passwordOK: false,

      // Google2FA
      google2FAEnabled: false,
      showGoogle2FASetup: false,
      google2FAConfig: { secret: '', url: '' },
      firstOTP: '',
      google2FAError: '',
      qrCodeUrl: ''
    }
  },
  mounted() {
    this.getMandant();
    this.getAuthentication();
    this.getLastLogins();
  },
  methods: {
    getMandant: function () {
      var postData = {}
      var self = this
      const url = self.$path + 'api/mandant/v1';

      axios.get(url, postData, self.$settings)
    .then(function (response) {
      self.mandant = response.data.response[0]
      
    })
  },

    async getAuthentication() {
      try {
        const url = this.$path + 'api/authentication/v1/';
        const response = await axios.get(url, this.$settings);
        this.google2FAEnabled = response.data.response['2fa_type'] === 'google2fa';
      } catch(e) {
        console.error(e);
      }
    },

    async getLastLogins() {
      try {
        const url = this.$path + 'api/authentication/v1/log';
        const response = await axios.get(url, this.$settings);
        this.logins = response.data.response;
      } catch(e) {
        console.error(e);
      }
    },
    

    updateLocalPassword: async function() {
      const password = document.getElementById("oldPassword").value;
      const newPassword = document.getElementById("newPassword").value;
      const r = await this.updatePassword(password, newPassword);
      if (r == "reset") {
        this.passwordOK = false;
        document.getElementById("oldPassword").value = "";
        document.getElementById("newPassword").value = "";
        document.getElementById("newPassword2").value = "";
      }
    },

    checkLocalPassword: async function() {
      const oldPassword = document.getElementById("oldPassword").value;
      const newPassword = document.getElementById("newPassword").value;
      const newPassword2 = document.getElementById("newPassword2").value;
      const error = await this.checkPassword(oldPassword, newPassword, newPassword2);

      if (!error) {
        this.errormessageText = "";
        this.passwordOK = true;
      } else if (error === "-") {
        this.errormessageText = "";
        this.passwordOK = false;
      } else {
        this.errormessageText = this.LangCheckPasswordPolicyText(error);
        this.passwordOK = false;
      }
    },

    // --- Google2FA ---
    startGoogle2FASetup: async function() {
      this.google2FAError = '';
      this.showGoogle2FASetup = true;

      const url = this.$path + 'api/authentication/v1/otp/google/generatesecret';
      try {
        const response = await axios.put(url, {}, this.$settings);
        this.google2FAConfig = response.data.response;
        this.qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' +
                         encodeURIComponent(this.google2FAConfig.url);
      } catch(e) {
        this.google2FAError = 'Fehler beim Generieren des Google2FA-Secret.';
        console.error(e);
      }
    },

    confirmGoogle2FA: async function() {
      this.google2FAError = '';
      const url = this.$path + 'api/authentication/v1/otp/google/confirm';
      try {
        const body = { code: this.firstOTP };
        const response = await axios.put(url, body, this.$settings);
        if (response.status === 200) {
          this.google2FAEnabled = true;
          this.showGoogle2FASetup = false;
          Swal.fire({ title: "Erfolg", html: "Die Zwei-Faktor-Authentifizierung per Google wurde erfolgreich aktiviert.", icon: null, position: "top-end", confirmButtonColor: "#A6C516" });
        } else {
          this.google2FAError = 'Ungültiger OTP-Code';
        }
      } catch(e) {
        this.google2FAError = 'Fehler beim Bestätigen des OTP.';
        console.error(e);
      }
    },

    promptResetGoogle2FA: async function() {
      const { value: code } = await Swal.fire({
        title: 'Google2FA deaktivieren',
        input: 'text',
        inputLabel: 'Letzter OTP-Code',
        inputPlaceholder: 'Geben Sie Ihren letzten OTP-Code ein',
        inputAttributes: {
          maxlength: 6,
          autocapitalize: 'off',
          autocorrect: 'off'
        },
        showCancelButton: true
      });

      if (code) {
        this.resetGoogle2FA(code);
      }
    },

    resetGoogle2FA: async function(code) {
      this.google2FAError = '';
      const url = this.$path + 'api/authentication/v1/otp/google/disable';
      try {
        const response = await axios.put(url, { code }, this.$settings);
        if (response.status === 200) {
          this.google2FAEnabled = false;
          Swal.fire({ title: "Erfolg", html: "Die Zwei-Faktor-Authentifizierung per Google wurde erfolgreich deaktiviert.", icon: null, position: "top-end", confirmButtonColor: "#A6C516" });
        } else {
          this.google2FAError = 'Ungültiger OTP-Code';
        }
      } catch(e) {
        this.google2FAError = 'Fehler beim Zurücksetzen der Zwei-Faktor-Authentifizierung.';
        console.error(e);
      }
    }
  }
}
</script>
